import { DefaultState } from 'store/types';

export const REACTIVATE_LODGING_OPTION_REQUEST = 'REACTIVATE_LODGING_OPTION_REQUEST';
export const REACTIVATE_LODGING_OPTION_SUCCESS = 'REACTIVATE_LODGING_OPTION_SUCCESS';
export const REACTIVATE_LODGING_OPTION_FAILURE = 'REACTIVATE_LODGING_OPTION_FAILURE';

export interface ReactivateLodgingOptionData {

};

export type ReactivateLodgingOptionState = DefaultState & {
  contents?: ReactivateLodgingOptionData;
};

interface ReactivateLodgingOptionRequest {
  type: typeof REACTIVATE_LODGING_OPTION_REQUEST;
};

interface ReactivateLodgingOptionSuccess {
  type: typeof REACTIVATE_LODGING_OPTION_SUCCESS,
  contents: ReactivateLodgingOptionData;
}

interface ReactivateLodgingOptionFailure {
  type: typeof REACTIVATE_LODGING_OPTION_FAILURE;
}

export type ReactivateLodgingOptionActionTypes = ReactivateLodgingOptionRequest | ReactivateLodgingOptionSuccess | ReactivateLodgingOptionFailure;